import type { GraphqlClientRoute, GraphqlClientSource } from "@ark/shared";

export const getGraphqlClientRoute = (pathname: string): GraphqlClientRoute => {
  const segmentList = pathname.split("/").filter(Boolean);
  if (segmentList.length === 0) return "root";

  const [firstSegment, secondSegment, thirdSegment, fourthSegment] = segmentList;
  if (firstSegment === "login" || firstSegment === "auth") return "auth";
  if (firstSegment === "admin") return "admin";
  if (firstSegment === "embed" || secondSegment === "embed") return "embed";
  if (firstSegment === "print" && secondSegment === "dashboard") return "print/dashboard";

  if (secondSegment === "inventories") {
    if (thirdSegment === undefined) return "inventories";
    if (thirdSegment === "all") return "inventories/all";
    if (thirdSegment === "dashboard") return "inventories/dashboard";
    if (thirdSegment === "trash") return "inventories/trash";
    if (fourthSegment === "details") return "inventories/details";
    if (fourthSegment === "evaluation") return "inventories/evaluation";
    if (fourthSegment === "activity") return "inventories/activity";
    if (fourthSegment === "data") return "inventories/data";
    return "inventories/detail";
  }
  if (secondSegment === "scenarios") return "scenarios";
  if (secondSegment === "settings") {
    return thirdSegment === "workspace" && fourthSegment === "population" ? "settings/population" : "settings";
  }
  if (secondSegment === "climate-actions") return "climate-actions";
  if (secondSegment === "public-dashboards") return "public-dashboards";

  return "other";
};

export const getGraphqlClientContextHeaders = (
  source: GraphqlClientSource = "other",
): Record<string, GraphqlClientRoute | GraphqlClientSource> => ({
  "x-client-route": typeof window === "undefined" ? "other" : getGraphqlClientRoute(window.location.pathname),
  "x-client-source": source,
});
